// removed by extract-text-webpack-plugin
module.exports = {"subscriptions-news":"subscriptions-news","form-group":"form-group","group-radio":"group-radio","group-checkbox":"group-checkbox","delimiter":"delimiter","subscriptions-news__form":"subscriptions-news__form","subscriptions-news__personal-agreement":"subscriptions-news__personal-agreement","subscriptions-news__submit":"subscriptions-news__submit"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_subscriptions-news.scss
// module id = 99
// module chunks = 0